import React from 'react';
import ReactDOM from 'react-dom/client';
import AmexReconciliation from './AmexReconciliation';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AmexReconciliation />);
